import { accessRole } from "../../../../helpers/access_role"

import React, { Fragment, Component } from "react"
import apiResponse from "../../../../services/apiResponse"

import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
    Input,
    Modal,ModalBody,ModalFooter, ModalHeader,
    Spinner,
    Label, UncontrolledAlert
} from "reactstrap"

import moment from "moment"
import { ConfirmAlert } from '../../../../helpers/ui/alert'

import Select from "react-select"
import YearSelect from '../../../../helpers/ui/YearSelect';
import Shimmer from "react-shimmer-effect";

import TableActiveComponent from './Components/TableActiveComponent'
import IndexBloc from "./Blocs/IndexBloc"

class IndexView extends Component {

    indexBloc = new IndexBloc();

    constructor(props) {
      super(props)
      this.state = {
        nip: '',
        name: '',
        yearPeriode : {
          value : new Date().getFullYear()
        },
        optionUnits: [],
        selectedUnit: {value:''},
        yearPeriodeCount : 0,
        loadingCurrent: true
      }

      this.activeRef =  React.createRef()
    }

    reformatOptions = (sources, label, value) => {
      return sources.map(function(source) {
        var newObj = {};
        newObj["label"] = source[label];
        newObj["value"] = source[value];
    
        return newObj;
      })
    }
    
    checkYear = () => {
      this.indexBloc.fetchCheckYear({year: this.state.yearPeriode.value })
    }

    reloadActiveRef = () => this.activeRef.current.setTokenAPI()

    handleButtonSearch = () => {
      this.reloadActiveRef();
    }

    handleButtonReset = () => {
      this.setState({
        nip: '',
        name: '',
        selectedUnit: ''
      })

      setTimeout(() => {
        this.reloadActiveRef()
      }, 100);
    }

    handleSelectYear = (selectedYear) => {
      this.setState({
        yearPeriode : selectedYear
      })

      setTimeout(() => {
        this.checkYear()
      }, 100);
    }

    handleSelectUnit = (selectedUnit) => {
      this.setState({
        selectedUnit : selectedUnit
      })
    }

    submitData = async () => {
        await this.indexBloc.fetchCreatePeriode({year: this.state.yearPeriode.value})
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
            case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    componentDidMount() {
      this.indexBloc.checkYearChannel.subscribe((result) => {
          switch (result.status) {
              case apiResponse.LOADING:
                  this.setState({
                      loadingCurrent: true
                  });
                  break
              case apiResponse.COMPLETED:
                  if(result.data.status) {
                      let response = result.data.response
                      console.log(response)
                      this.setState({
                        loadingCurrent: false,
                        yearPeriodeCount : response.count
                      })
                      if (response.count > 0){
                        this.reloadActiveRef()
                      }
                  }
                  break
              case apiResponse.ERROR:
                  
                  break
              default:
                  break
          }
      })

      this.indexBloc.createPeriodeChannel.subscribe((result) => {
          switch (result.status) {
              case apiResponse.COMPLETED:
                  this.setState({
                      loading: false,
                      success: true,
                  });
                  this.checkYear();
                  break
              case apiResponse.ERROR:
                  this.setState({
                      loading: false,
                      failed: true,
                  });
                  break
              default:
                  break
          }
      }) 

      this.indexBloc.workUnitChannel.subscribe((result) => {
          switch (result.status) {
              case apiResponse.COMPLETED:
                  if(result.data.status) {
                      let response = result.data.response.result
                      this.setState({
                          optionUnits: this.reformatOptions(
                              response, 
                              'work_unit_name_tabs',
                              'work_unit_uuid'
                          )
                      })
                  }
                  break
              case apiResponse.ERROR:
                  
                  break
              default:
                  break
          }
      })
      this.indexBloc.fetchWorkUnit({})

      this.indexBloc.exportExcelChannel.subscribe((result) => {
          switch (result.status) {
              case apiResponse.LOADING:
                  this.setState({
                      loading: true,
                  })
                  break
              case apiResponse.COMPLETED:
                  const link = result.data.response
                  //window.open(link, "_blank")
                  window.location.href = link.file_url
                  this.setState({
                      loading: false,
                      success: true
                  })
                  setTimeout(() => {
                      this.setState({
                          success: false,
                      })
                  }, 1000);
                  break
              case apiResponse.ERROR:
                  this.setState({
                      urlFileDetail: link,
                      loading: false,
                      failed: true
                  })
                  setTimeout(function() {
                      this.setState({
                          failed: false,
                      })
                  }, 1000)
                  break
              default:
                  break
          }
      })

      this.indexBloc.exportExcelEmpChannel.subscribe((result) => {
          switch (result.status) {
              case apiResponse.LOADING:
                  this.setState({
                      loading: true,
                  })
                  break
              case apiResponse.COMPLETED:
                  const link = result.data.response
                  //window.open(link, "_blank")
                  window.location.href = link.file_url
                  this.setState({
                      loading: false,
                      success: true
                  })
                  setTimeout(() => {
                      this.setState({
                          success: false,
                      })
                  }, 1000);
                  break
              case apiResponse.ERROR:
                  this.setState({
                      urlFileDetail: link,
                      loading: false,
                      failed: true
                  })
                  setTimeout(function() {
                      this.setState({
                          failed: false,
                      })
                  }, 1000)
                  break
              default:
                  break
          }
      })

      this.indexBloc.downloadLetterChannel.subscribe((result) => {
        switch (result.status) {
            case apiResponse.LOADING:
                this.setState({
                    loading: true,
                })
                break
            case apiResponse.COMPLETED:
                const link = result.data.response
                window.open(link.file_url, "_blank")
                //window.location.href = link.file_url
                this.setState({
                    loading: false,
                    success: true
                })
                setTimeout(() => {
                    this.setState({
                        success: false,
                    })
                }, 1000);
                break
            case apiResponse.ERROR:
                this.setState({
                    urlFileDetail: link,
                    loading: false,
                    failed: true
                })
                setTimeout(function() {
                    this.setState({
                        failed: false,
                    })
                }, 1000)
                break
            default:
                break
        }
    })

      this.checkYear()
    }

    componentWillUnmount(){
      this.indexBloc.checkYearChannel.unsubscribe()
      this.indexBloc.workUnitChannel.unsubscribe()
      this.indexBloc.exportExcelChannel.unsubscribe()
      this.indexBloc.exportExcelEmpChannel.unsubscribe()
      this.indexBloc.downloadLetterChannel.unsubscribe()
    }
    
    render() {
      
      let additionalFilter = {
        year: this.state.yearPeriode.value,
        nip: this.state.nip,
        name: this.state.name,
        work_unit: this.state.selectedUnit.value
      }

      return (
          <Fragment>
              <Container fluid>
                  <Row>
                      <Col xs="12">
                          
                          <Card>
                              <CardBody>
                                  <div className="float-end">
                                  {/* {
                                      (accessRole('create')) ?
                                          <Link to="home.html?create">
                                              <Button color="primary">New Sample</Button>
                                          </Link>
                                      : null
                                  } */}
                                  </div>
                                  <CardTitle>List Data Indeks Professionalitas Pegawai</CardTitle>
                                  <CardSubtitle className="mb-3">
                                      {/* Daftar Urut Kepangkatan */}
                                  </CardSubtitle>
                                  <hr />
  
                                  <Row className="mb-3">
                                      <Label
                                          htmlFor="fieldTahun"
                                          className="col-md-2 col-form-label"
                                      >
                                          Periode Tahun <span className="text-danger">*</span>
                                      </Label>
                                      <Col md="2">
                                          <YearSelect 
                                              name="periode_year"
                                              errorMessage="Masukkan Tahun"
                                              placeholder="Tahun..."
                                              onChange={this.handleSelectYear}
                                              isAvForm={false}
                                          />
                                      </Col>
                                      <Col md="8">
                                          {/* <Button 
                                              color="primary" 
                                              type="button"
                                              onClick={() => {
                                                  this.handleYearSelect()
                                              }}
                                          >
                                              <i className="uil-search-alt"></i> Pilih Tahun
                                          </Button> */}
                                          {
                                            this.state.loadingCurrent ? 
                                              <Shimmer><div style={{width: '20%', height: 40}}></div></Shimmer>
                                            : 
                                              <>
                                                {
                                                  this.state.yearPeriodeCount > 0 ?
                                                    <>
                                                      <Button 
                                                          color="warning" 
                                                          type="button"
                                                          onClick={() => {
                                                              this.setState({
                                                                confirm : true
                                                              })
                                                          }}>
                                                          <i className="uil-file-download-alt"></i> Update Periode
                                                      </Button>
                                                    </>
                                                  :
                                                    <>
                                                      <Button 
                                                          color="success" 
                                                          type="button"
                                                          onClick={() => {
                                                              this.setState({
                                                                confirm : true
                                                              })
                                                          }}>
                                                          <i className="uil-file-download-alt"></i> Buat Periode
                                                      </Button>
                                                    </>
                                                }
                                              </>
                                          }
                                      </Col>
                                  </Row>
  
                                  <hr />

                                  {
                                    this.state.loadingCurrent ? 
                                      <Shimmer><div style={{width: '100%', height: 40}}></div></Shimmer>
                                      :
                                      <>
                                        {
                                          this.state.yearPeriodeCount > 0 ? 
                                            <>
                                              <Row className="mb-3">
                                                  <label
                                                      htmlFor="fielCode"
                                                      className="col-md-2 col-form-label"
                                                  >
                                                  NIP
                                                  </label>
                                                  <Col md="4">
                                                      <Input
                                                          type="text"
                                                          name="nip"
                                                          value={this.state.nip}
                                                          onChange={event => this.setState({nip: event.target.value}) }
                                                      >
                                                  </Input>
                                                  </Col>
                                              </Row>

                                              <Row className="mb-3">
                                                  <label
                                                      htmlFor="fielCode"
                                                      className="col-md-2 col-form-label"
                                                  >
                                                  Nama
                                                  </label>
                                                  <Col md="4">
                                                      <Input
                                                          type="text"
                                                          name="name"
                                                          value={this.state.name}
                                                          onChange={event => this.setState({name: event.target.value}) }
                                                      >
                                                  </Input>
                                                  </Col>
                                              </Row>

                                              <Row className="mb-3">
                                                  <label
                                                      htmlFor="gender"
                                                      className="col-md-2 col-form-label"
                                                  >
                                                  Unit Kerja
                                                  </label>
                                                  <Col md="6">
                                                      <Select
                                                          value={this.state.optionUnits.filter(option => 
                                                            option.value === this.state.selectedUnit.value)}
                                                          onChange={this.handleSelectUnit}
                                                          required="required"
                                                          options={this.state.optionUnits}
                                                          classNamePrefix="select2-unit"
                                                      />
                                                  </Col>
                                              </Row>

                                              <Row className="mb-3">
                                                  <Col md="2"></Col>
                                                  <Col md="10">
                                                      <Button 
                                                          color="primary" 
                                                          type="button"
                                                          onClick={() => {
                                                              this.handleButtonSearch()
                                                          }}
                                                      >
                                                          <i className="uil-search-alt"></i> Cari
                                                      </Button>
                                                      {' '}
                                                      <Button 
                                                        color="warning" 
                                                        type="button"
                                                        onClick={() => {
                                                             this.handleButtonReset()
                                                        }}>
                                                          <i className="uil-refresh"></i> Reset
                                                      </Button>
                                                      {' '}
                                                      <Button 
                                                        color="success" 
                                                        type="button"
                                                        onClick={() => {
                                                          this.indexBloc.fetchExportExcel({
                                                              year: this.state.yearPeriode.value, 
                                                              work_unit_uuid: this.state.selectedUnit.value || ''})
                                                        }}>
                                                          <i className="uil-file-download"></i> Export Pelaporan Unit Kerja
                                                      </Button>
                                                      {' '}
                                                      <Button 
                                                        color="success" 
                                                        type="button"
                                                        onClick={() => {
                                                          this.indexBloc.fetchExportExcelEmp({
                                                              year: this.state.yearPeriode.value, 
                                                              work_unit_uuid: this.state.selectedUnit.value || ''})
                                                        }}>
                                                          <i className="uil-file-download"></i> Export Pelaporan Pegawai
                                                      </Button>
                                                      {' '}
                                                      <Button 
                                                        color="danger" 
                                                        type="button"
                                                        onClick={() => {
                                                          this.indexBloc.fetchDownloadLetter({year: this.state.yearPeriode.value})
                                                        }}>
                                                          <i className="uil-file-alt"></i> Surat Pernyataan
                                                      </Button>
                                                  </Col>
                                              </Row>
                                              <hr />
                                              <TableActiveComponent ref={this.activeRef} additionalFilter={additionalFilter} />
                                            </>
                                          :
                                            <UncontrolledAlert
                                                color="warning"
                                                className="alert-dismissible fade show"
                                                role="alert"
                                            >
                                            <i className="uil uil-exclamation-triangle me-2"></i> Belum ada data indeks professionalitas untuk periode tahun {this.state.yearPeriode.value}. Silahkan klik buat periode untuk membuat data.
                                            </UncontrolledAlert>
                                        }
                                      </>
                                  }

                              </CardBody>
                          </Card>
                          
                         
                      </Col>
                  </Row>
              </Container>
              <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo={`Apakah anda yakin akan memproses data Indeks Professionalitas untuk tahun ${this.state.yearPeriode.value}?`}

                    loadingTitle="Memproses data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil diproses"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
          </Fragment>
      )
    }
}

export default IndexView